var map = {
	"./apple_pay.svg": 5300,
	"./credit_card.svg": 3163,
	"./fonts/dashboard-icons.svg": 7573,
	"./giftcard.svg": 2285,
	"./interac.svg": 9741,
	"./jcb.svg": 6498,
	"./ready-progress-spinner-gray-fullsize.svg": 8319,
	"./ready-progress-spinner-gray.svg": 9558,
	"./ready-progress-spinner-white.svg": 418,
	"./ready-progress-spinner.svg": 3078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1965;